import { HelpIcon } from '../../../../icons';

import styles from './_index.module.scss';

export interface SuggestionsWrapperProps {
  children: React.ReactNode;
  description?: string;
  helpUrl?: string;
  title?: string;
}

const SuggestionsWrapper = ({ children, description, helpUrl, title }: SuggestionsWrapperProps) => {
  return (
    <>
      <div className={styles['suggestions-wrapper-header']}>
        {helpUrl && (
          <a aria-label="Help" href={helpUrl} rel="noreferrer" target="_blank">
            <HelpIcon />
          </a>
        )}
        <h4>{title}</h4>
        {description && <p>{description}</p>}
      </div>
      <div className={styles['suggestions-wrapper-list']}>{children}</div>
    </>
  );
};

export default SuggestionsWrapper;
